import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import moment from 'moment';
import dateMessages from '@/shared/messages/dateMessages';

const generateYears = (yearFrom, yearUntil, showAll) => {
  const years = [];
  for (let year = yearFrom; year <= yearUntil; year++) {
    years.push({
      key: `${year}`,
      value: year,
      label: `${year}`,
    });
  }
  if (showAll) {
    years.push({
      key: 'all',
      value: null,
      label: dateMessages.All,
    });
  }
  return years;
};

const YearButtonGroup = ({ value, yearFrom, yearUntil, showAll, onChange, className }) => {
  const years = useMemo(() => generateYears(yearFrom, yearUntil, showAll), [
    yearFrom,
    yearUntil,
    showAll,
  ]);

  return (
    <div
      role="group"
      aria-label="period"
      className={classnames(className, 'btn-group btn-group-justified')}
    >
      {years.map(p => (
        <button
          onClick={() => onChange(p.value)}
          type="button"
          key={p.key}
          className={classnames('btn btn-default', {
            active: value === p.value,
          })}
        >
          {p.label && p.label.id ? <FormattedMessage {...p.label} /> : p.label}
        </button>
      ))}
    </div>
  );
};

YearButtonGroup.propTypes = {
  value: PropTypes.number,
  yearFrom: PropTypes.number,
  yearUntil: PropTypes.number,
  showAll: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

YearButtonGroup.defaultProps = {
  value: null,
  yearFrom: moment.utc().year() - 3,
  yearUntil: moment.utc().year(),
  showAll: false,
  className: '',
};
export default YearButtonGroup;
